import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../stores/userStore';
import { useUIStore } from '../stores/uiStore';
import { getTitleForScore, TITLES } from '@beast-keeper/shared';
import { useEffect } from 'react';

export default function HomeScreen() {
  const navigate = useNavigate();
  const { nickname, bestScore, bestTitle, token, fetchProfile } = useUserStore();
  const openNicknameModal = useUIStore((s) => s.openNicknameModal);

  useEffect(() => {
    if (token) fetchProfile();
  }, [token, fetchProfile]);

  const handleStart = () => {
    if (!nickname) {
      openNicknameModal(() => navigate('/quiz'));
    } else {
      navigate('/quiz');
    }
  };

  const bestInfo = bestScore > 0 && bestTitle
    ? (() => {
        const t = TITLES.find((x) => x.name === bestTitle) || getTitleForScore(bestScore);
        return `${t.icon} ${t.name} · ${bestScore} 分`;
      })()
    : '暂无战绩，快来挑战吧！';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: 'var(--space-lg) var(--space-md)' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
        {/* Hero */}
        <div style={{ textAlign: 'center', padding: 'var(--space-xl) 0 var(--space-lg)' }}>
          <div className="home-float" style={{ position: 'relative', height: 80, marginBottom: 'var(--space-sm)' }}>
            <span style={{ position: 'absolute', fontSize: '2rem', left: '15%', animation: 'floatAround 4s ease-in-out infinite' }}>🍼</span>
            <span style={{ position: 'absolute', fontSize: '2rem', left: '45%', animation: 'floatAround 4s ease-in-out 0.6s infinite', top: 8 }}>🧸</span>
            <span style={{ position: 'absolute', fontSize: '2rem', left: '72%', animation: 'floatAround 4s ease-in-out 1.2s infinite' }}>🦖</span>
          </div>
          <div className="home-logo">神兽饲养员</div>
          <p className="home-slogan">"带娃是门技术活，敢来测测你的神气值吗？"</p>
        </div>

        {/* Best badge */}
        <div className="best-badge" style={{ width: '100%' }}>
          <div className="label">历史最佳战绩</div>
          <div className="value">{bestInfo}</div>
        </div>

        {/* Actions */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', paddingBottom: 'var(--space-sm)' }}>
          <button className="btn btn-primary btn-lg btn-glow" onClick={handleStart}>
            🍼 我准备好换尿布了！
          </button>
          <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
            <button className="btn btn-secondary btn-sm" style={{ flex: 1 }} onClick={() => navigate('/leaderboard')}>
              🏆 排行榜
            </button>
            <button className="btn btn-secondary btn-sm" style={{ flex: 1 }} onClick={() => navigate('/titles')}>
              📜 名号殿堂
            </button>
          </div>
        </div>
      </div>

      {/* Version stamp — for verifying deployment */}
      <div style={{ fontSize: 10, color: 'var(--color-text-secondary)', opacity: 0.4, textAlign: 'center', paddingBottom: 4 }}>
        build {__BUILD_TIME__.slice(0, 16).replace('T', ' ')}
      </div>

      <style>{`
        @keyframes floatAround {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          30%  { transform: translateY(-16px) rotate(6deg); }
          60%  { transform: translateY(-4px) rotate(-4deg); }
        }
      `}</style>
    </div>
  );
}
